import React, { lazy, Suspense } from 'react';

import { Head as SEO } from '@landing/components';
import Header from 'components/Header';
import Intro from 'components/Intro';
import About from 'components/About';
import QuickFacts from 'components/QuickFacts';
import Artists from 'components/Artists';
import Artworks from 'components/Artworks';
import Events from 'components/Events';
import Gallery from 'components/Gallery';
import Location from 'components/Location';
import Footer from 'components/Footer';
import CookiesPolicy from 'components/CookiesPolicy';
import { anchorLinks } from 'define/anchorLinks';

import data from './data.json';

const ConsentModal = lazy(() =>
  import('components/Modals').then(({ ConsentModal }) => ({
    default: ConsentModal,
  })),
);

const RequestConsultation = lazy(() =>
  import('components/Modals').then(({ RequestConsultation }) => ({
    default: RequestConsultation,
  })),
);

const SuccessModal = lazy(() =>
  import('components/Modals').then(({ SuccessModal }) => ({
    default: SuccessModal,
  })),
);

const ErrorModal = lazy(() =>
  import('components/Modals').then(({ ErrorModal }) => ({
    default: ErrorModal,
  })),
);

export default function Index() {
  const isSsr = typeof window === 'undefined';

  return (
    <>
      <Header anchorLinks={anchorLinks} />
      <Intro {...data.intro} />
      <About {...data.about} />
      <QuickFacts {...data.quickFacts} />
      <Artists {...data.artists} />
      <Artworks {...data.artworks} />
      <Events {...data.events} />
      <Gallery {...data.gallery} />
      <Artists {...data.organisers} />
      <Location {...data.location} />
      <Footer anchorLinks={anchorLinks} {...data.footer} />
      <CookiesPolicy />
      {!isSsr && (
        <Suspense fallback={null}>
          <ConsentModal />
          <RequestConsultation />
          <SuccessModal />
          <ErrorModal />
        </Suspense>
      )}
    </>
  );
}

export const Head = () => <SEO {...data.head} />;
